"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const Box_1 = __importDefault(require("@mui/material/Box"));
const Table_1 = __importDefault(require("@mui/material/Table"));
const TableRow_1 = __importDefault(require("@mui/material/TableRow"));
const TableHead_1 = __importDefault(require("@mui/material/TableHead"));
const TableBody_1 = __importDefault(require("@mui/material/TableBody"));
const TableCell_1 = __importDefault(require("@mui/material/TableCell"));
const TableContainer_1 = __importDefault(require("@mui/material/TableContainer"));
const IconButton_1 = __importDefault(require("@mui/material/IconButton"));
const Typography_1 = __importDefault(require("@mui/material/Typography"));
const Add_1 = __importDefault(require("@mui/icons-material/Add"));
const Remove_1 = __importDefault(require("@mui/icons-material/Remove"));
const styles_1 = require("@mui/material/styles");
const styles_2 = require("../styles");
const utils_1 = require("../utils");
const state_1 = require("../state");
const IncomeExpenseReportTableRow_1 = __importDefault(require("./IncomeExpenseReportTableRow"));
const US_DATE_FORMAT = 'M/d/yy';
const totalRowTypographyStyles = { ml: 5 };
const IncomeExpenseReportTable = ({ chartData, expenseData, incomeData, handleReportTableCellSelect, handleClearButtonClick, interval, breakdownType, }) => {
    const { state } = (0, react_1.useContext)(state_1.ReportsStateContext);
    const { selectedGraphCategory, timeStep } = state;
    const [isIncomeExpanded, setIsIncomeExpanded] = (0, react_1.useState)(true);
    const [isExpenseExpanded, setIsExpenseExpanded] = (0, react_1.useState)(true);
    const { palette } = (0, styles_1.useTheme)();
    const colorLightBlue = palette.action.selected;
    const colorLightGray = palette.background.default;
    const overallTotalCellStyles = { bgcolor: colorLightGray, border: `1px solid ${palette.border.dark}`, borderTop: 'none' };
    const overallTotalIncome = (0, react_1.useMemo)(() => chartData ? chartData.reduce((accumulator, chartDataRecord) => accumulator + chartDataRecord.incomeTotalForReport, 0) : 0, [chartData]);
    const overallTotalExpense = (0, react_1.useMemo)(() => chartData ? chartData.reduce((accumulator, chartDataRecord) => accumulator + chartDataRecord.spendingTotalForReport, 0) : 0, [chartData]);
    if (!chartData || chartData.length <= 0) {
        return null;
    }
    const isValidInterval = interval !== 'none';
    const primaryColumnLabel = breakdownType === 'payee' ? 'Payee' : 'Category';
    const chartDataToDisplay = isValidInterval ? chartData : [];
    return (<Box_1.default p={2} id="report-container">
      <Typography_1.default variant="body1" mb={4} id="report-header" color="text.primary" fontWeight={500} fontSize={18}>
        Report
      </Typography_1.default>
      <TableContainer_1.default sx={{ overflowY: 'auto', maxHeight: 407 }}>
        <Table_1.default stickyHeader aria-label="income vs expense report data table">
          <TableHead_1.default>
            <TableRow_1.default key="duration-row">
              <styles_2.StickyTableHead key="duration-row-category-cell" sx={{ border: `1px solid ${palette.border.dark}`, minWidth: '250px' }}>
                {primaryColumnLabel}
              </styles_2.StickyTableHead>
              {chartDataToDisplay.map(({ category, periodStartDate, periodEndDate }) => (<TableCell_1.default key={category} id={category} sx={{
                py: 0,
                px: 1,
                minWidth: '155px',
                bgcolor: (0, utils_1.checkIfSelectedCategoryEquals)(selectedGraphCategory, category) ? colorLightBlue : colorLightGray,
                borderTop: `1px solid ${palette.border.dark}`,
                borderBottom: `1px solid ${palette.border.dark}`,
            }} align="right">
                  {timeStep === 'quarters' && (<Typography_1.default variant="subtitle2">{periodEndDate.toFormat('M/yyyy')}</Typography_1.default>)}
                  <Typography_1.default variant="subtitle2">
                    {`${periodStartDate.toFormat(US_DATE_FORMAT)} - ${periodEndDate.toFormat(US_DATE_FORMAT)}`}
                  </Typography_1.default>
                </TableCell_1.default>))}
              <styles_2.StickyTableCellRight align="right" sx={{
            border: `1px solid ${palette.border.dark}`,
            bgcolor: colorLightGray,
            minWidth: '120px',
            zIndex: '3 !important',
            p: 1,
        }}>
                <Typography_1.default variant="subtitle2">Overall Total</Typography_1.default>
              </styles_2.StickyTableCellRight>
            </TableRow_1.default>
          </TableHead_1.default>
          <TableBody_1.default>
            <TableRow_1.default key="income-sub-header-row">
              <styles_2.StickyTableCellLeft key="income-sub-header-row-main-cell" sx={Object.assign({ p: 0 }, overallTotalCellStyles)}>
                <Typography_1.default variant="subtitle2">
                  <IconButton_1.default onClick={(event) => {
            event.stopPropagation();
            setIsIncomeExpanded(!isIncomeExpanded);
        }} sx={{ py: 0 }}>
                    {isIncomeExpanded ? <Remove_1.default /> : <Add_1.default />}
                  </IconButton_1.default>
                  Income
                </Typography_1.default>
              </styles_2.StickyTableCellLeft>
              {chartDataToDisplay.map(({ category }) => (<TableCell_1.default key={category} sx={{
                borderBottom: `1px solid ${palette.border.dark}`,
                bgcolor: (0, utils_1.checkIfSelectedCategoryEquals)(selectedGraphCategory, category) ? colorLightBlue : colorLightGray,
            }}/>))}
              <styles_2.StickyTableCellRight align="right" sx={overallTotalCellStyles}/>
            </TableRow_1.default>
            {isIncomeExpanded && incomeData ? incomeData.map(({ rowId, categoryId, groupKey, indentation, periods, total }) => (<IncomeExpenseReportTableRow_1.default key={rowId || categoryId} rowId={rowId || categoryId} groupKey={groupKey} indentation={indentation} total={total} periods={isValidInterval ? periods : []} palette={palette} colorLightBlue={colorLightBlue} handleReportTableCellSelect={handleReportTableCellSelect} handleClearButtonClick={handleClearButtonClick} section="income"/>)) : null}
            <TableRow_1.default key="total-income-row">
              <styles_2.StickyTableCellLeft align="left" key="total-income-cell" sx={{
            p: 0,
            border: `1px solid ${palette.border.dark}`,
            borderBottom: 'none',
            bgcolor: palette.background.paper,
        }}>
                <Typography_1.default variant="subtitle2" sx={totalRowTypographyStyles}>
                  Total Income
                </Typography_1.default>
              </styles_2.StickyTableCellLeft>
              {chartDataToDisplay.map(({ category, incomeTotalForReport = 0 }) => (<TableCell_1.default key={category} align="right" sx={{
                py: 0,
                px: 1,
                borderTop: `1px solid ${palette.border.dark}`,
                borderBottom: 'none',
                bgcolor: (0, utils_1.checkIfSelectedCategoryEquals)(selectedGraphCategory, category) ? colorLightBlue : 'initial',
            }}>
                  <Typography_1.default variant="subtitle2" sx={Object.assign(Object.assign({}, totalRowTypographyStyles), { pr: 0.75 })}>
                    {incomeTotalForReport.toFixed(2)}
                  </Typography_1.default>
                </TableCell_1.default>))}
              <styles_2.StickyTableCellRight align="right" sx={{
            border: `1px solid ${palette.border.dark}`,
            borderBottom: 'none',
            bgcolor: palette.background.paper,
        }}>
                <Typography_1.default variant="subtitle2">
                  {overallTotalIncome.toFixed(2)}
                </Typography_1.default>
              </styles_2.StickyTableCellRight>
            </TableRow_1.default>
            <TableRow_1.default key="expense-sub-header-row">
              <styles_2.StickyTableCellLeft key="expense-sub-header-row-main-cell" sx={{
            p: 0,
            bgcolor: colorLightGray,
            border: `1px solid ${palette.border.dark}`,
        }}>
                <Typography_1.default variant="subtitle2">
                  <IconButton_1.default onClick={(event) => {
            event.stopPropagation();
            setIsExpenseExpanded(!isExpenseExpanded);
        }} sx={{ py: 0 }}>
                    {isExpenseExpanded ? <Remove_1.default /> : <Add_1.default />}
                  </IconButton_1.default>
                  Expenses
                </Typography_1.default>
              </styles_2.StickyTableCellLeft>
              {chartDataToDisplay.map(({ category }) => (<TableCell_1.default key={category} sx={{
                borderTop: `1px solid ${palette.border.dark}`,
                borderBottom: `1px solid ${palette.border.dark}`,
                bgcolor: (0, utils_1.checkIfSelectedCategoryEquals)(selectedGraphCategory, category) ? colorLightBlue : colorLightGray,
            }}/>))}
              <styles_2.StickyTableCellRight sx={{ bgcolor: colorLightGray, border: `1px solid ${palette.border.dark}` }}/>
            </TableRow_1.default>
            {isExpenseExpanded && expenseData ? expenseData.map(({ rowId, categoryId, groupKey, indentation, periods, total }) => (<IncomeExpenseReportTableRow_1.default key={rowId || categoryId} rowId={rowId || categoryId} groupKey={groupKey} indentation={indentation} total={total} periods={isValidInterval ? periods : []} palette={palette} colorLightBlue={colorLightBlue} handleReportTableCellSelect={handleReportTableCellSelect} handleClearButtonClick={handleClearButtonClick} showSign section="expense"/>)) : null}
            <TableRow_1.default key="total-expense-row">
              <styles_2.StickyTableCellLeft align="left" key="expense-overall-total-cell-left" sx={{
            p: 0,
            border: `1px solid ${palette.border.dark}`,
            borderBottom: 'none',
            bgcolor: palette.background.paper,
        }}>
                <Typography_1.default variant="subtitle2" sx={totalRowTypographyStyles}>
                  Total Expense
                </Typography_1.default>
              </styles_2.StickyTableCellLeft>
              {chartDataToDisplay.map(({ category, spendingTotalForReport = 0 }) => (<TableCell_1.default key={category} align="right" sx={{
                py: 1,
                borderTop: `1px solid ${palette.border.dark}`,
                borderBottom: 'none',
                bgcolor: (0, utils_1.checkIfSelectedCategoryEquals)(selectedGraphCategory, category) ? colorLightBlue : 'initial',
            }}>
                  <Typography_1.default variant="subtitle2">
                    {(-1 * spendingTotalForReport).toFixed(2)}
                  </Typography_1.default>
                </TableCell_1.default>))}
              <styles_2.StickyTableCellRight align="right" key="expense-overall-total-cell-right" sx={{
            border: `1px solid ${palette.border.dark}`,
            borderBottom: 'none',
            bgcolor: palette.background.paper,
        }}>
                <Typography_1.default variant="subtitle2">
                  {(-1 * overallTotalExpense).toFixed(2)}
                </Typography_1.default>
              </styles_2.StickyTableCellRight>
            </TableRow_1.default>
            <TableRow_1.default key="overall-totals-all">
              <styles_2.StickyTableCellLeft align="left" key="main-overall-total-cell-left" sx={{
            bottom: 0,
            bgcolor: palette.background.paper,
            zIndex: '3 !important',
            border: `1px solid ${palette.border.dark}`,
        }}>
                <Typography_1.default variant="subtitle2" sx={totalRowTypographyStyles}>
                  Overall Total
                </Typography_1.default>
              </styles_2.StickyTableCellLeft>
              {chartDataToDisplay.map(({ category, netIncomeTotal = 0 }) => (<styles_2.StickyTableCell key={category} align="right" sx={{
                bottom: 0,
                bgcolor: (0, utils_1.checkIfSelectedCategoryEquals)(selectedGraphCategory, category) ? colorLightBlue : palette.background.paper,
                borderTop: `1px solid ${palette.border.dark}`,
                borderBottom: `1px solid ${palette.border.dark}`,
            }}>
                  <Typography_1.default variant="subtitle2" pr={0.75}>
                    {netIncomeTotal.toFixed(2)}
                  </Typography_1.default>
                </styles_2.StickyTableCell>))}
              <styles_2.StickyTableCellRight key="main-overall-total-cell-right" align="right" sx={{
            bottom: 0,
            bgcolor: palette.background.paper,
            border: `1px solid ${palette.border.dark}`,
        }}>
                <Typography_1.default variant="subtitle2">
                  {(overallTotalIncome + overallTotalExpense).toFixed(2)}
                </Typography_1.default>
              </styles_2.StickyTableCellRight>
            </TableRow_1.default>
          </TableBody_1.default>
        </Table_1.default>
      </TableContainer_1.default>
    </Box_1.default>);
};
exports.default = IncomeExpenseReportTable;
